<template>
  <div class="product-detail-bottom-bar-left-slot">
    <trial-btn v-if="trialPrograms && trialPrograms.length !== 0"
               :trial-programs="trialPrograms"
    />
    <product-collect v-else-if="collect && collect.show"
                     class="product-detail-bottom-bar-left-slot-collect"
                     :target-type="targetType"
                     :target-id="targetId"
                     :status="collect.status"
                     position="bottom"
    />
  </div>
</template>

<script>
  import TrialBtn from '@/pages/Audio/components/AudioProgramTrialBtn';
  import ProductCollect from '@/components/ProductCollect';
  import validator from '@/utils/validator';

  export default {
    name: 'ProductDetailBottomBarLeftSlot',
    components: {
      TrialBtn,
      ProductCollect,
    },
    props: {
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
      trialPrograms: {
        type: Array,
        required: true,
      },
      collect: {
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-bottom-bar-left-slot {
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>
